module.exports = new __parcel__URL__("Racecar.f378b1ee.svg").toString();